import { Outlet } from 'react-router-dom';
import { TennisBall } from '@/components/icons/tennis-ball';

/**
 * Minimal focused layout for invite-code flows (/parent/onboard, /parent/join).
 * No sidebar, no nav — parent can't accidentally navigate away mid-flow.
 */
export default function OnboardLayout() {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      {/* Minimal header — just the wordmark */}
      <header className="flex items-center gap-2.5 px-6 py-4 border-b border-border">
        <div className="flex items-center justify-center w-8 h-8 rounded-lg bg-gradient-to-br from-emerald-500 to-teal-600 shadow-sm">
          <TennisBall className="w-4.5 h-4.5 text-white" />
        </div>
        <span className="font-bold text-base text-foreground">Tennis Locker</span>
      </header>

      {/* Page content — centered, max-width container */}
      <main className="flex-1 flex flex-col items-center justify-start py-6 px-4">
        <div className="w-full max-w-md">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
